export * from './student-default-layout.component';
